/* eslint-disable import/no-duplicates */
import { combineReducers } from "redux";
import {
  fetchArticlesReducer,
  fetchOneArticleReducer,
  createArticleReducer,
} from "./article.reducer";
import { loginReducer } from "./loginReducer";

const allReducers = combineReducers({
  fetchArticlesReducer,
  fetchOneArticleReducer,
  createArticleReducer,
  loginReducer,
});

export default allReducers;
